import React, { useEffect, useState } from 'react';

const CLIENT_ID = '177018948494-i9q570t9l0rk48esdg47tmbpmt73gvah.apps.googleusercontent.com';
const API_KEY = ''; // Your provided API Key
const SCOPES = 'https://www.googleapis.com/auth/gmail.readonly';
const DISCOVERY_DOCS = ['https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest'];

const Gmail = () => {
  const [emails, setEmails] = useState([]);
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Load the gapi client library
    const loadGapi = () => {
      window.gapi.load('client:auth2', initClient);
    };
    
    // Add a script tag to load gapi
    const script = document.createElement('script');
    script.src = 'https://apis.google.com/js/api.js';
    script.onload = loadGapi;
    document.body.appendChild(script);
  }, []);

  const initClient = () => {
    window.gapi.client.init({
      apiKey: API_KEY,
      clientId: CLIENT_ID,
      discoveryDocs: DISCOVERY_DOCS,
      scope: SCOPES,
    }).then(() => {
      const authInstance = window.gapi.auth2.getAuthInstance();
      setIsSignedIn(authInstance.isSignedIn.get());
      authInstance.isSignedIn.listen(setIsSignedIn);

      if (authInstance.isSignedIn.get()) {
        fetchEmails();
      }
    }).catch(error => {
      console.error('Error initializing GAPI client', error);
      setError('Failed to initialize Google API client. Check console for details.');
    });
  };

  const handleSignInClick = () => {
    window.gapi.auth2.getAuthInstance().signIn({
      scope: SCOPES,
    }).then(() => {
      console.log('Signed in successfully');
    }).catch(error => {
      console.error('Sign in error', error);
      setError('Failed to sign in. Check console for details.');
    });
  };
  

  const handleSignOutClick = () => {
    window.gapi.auth2.getAuthInstance().signOut();
  };

  const fetchEmails = () => {
    window.gapi.client.gmail.users.messages.list({
      userId: 'me',
      maxResults: 10,
    }).then(response => {
      const messages = response.result.messages;
      if (messages && messages.length > 0) {
        const emailPromises = messages.map(message =>
          window.gapi.client.gmail.users.messages.get({
            userId: 'me',
            id: message.id,
          })
        );

        Promise.all(emailPromises).then(emailResponses => {
          setEmails(emailResponses.map(email => email.result));
        }).catch(error => {
          console.error('Error fetching emails', error);
          setError('Failed to fetch emails. Check console for details.');
        });
      }
    }).catch(error => {
      console.error('Error fetching email list', error);
      setError('Failed to fetch email list. Check console for details.');
    });
  };

  return (
    <div>
      <h2>Gmail Inbox</h2>
      {error && <p>{error}</p>}
      {isSignedIn ? (
        <>
          <button onClick={handleSignOutClick}>Sign Out</button>
          <ul>
            {emails.map(email => (
              <li key={email.id}>
                <div>
                  <strong>From:</strong> {email.payload.headers.find(header => header.name === 'From').value}
                </div>
                <div>
                  <strong>Subject:</strong> {email.payload.headers.find(header => header.name === 'Subject').value}
                </div>
              </li>
            ))}
          </ul>
        </>
      ) : (
        <button onClick={handleSignInClick}>Sign In</button>
      )}
    </div>
  );
};

export default Gmail;
